module.exports = __webpack_public_path__ + "static/img/DSWS.199972d8.png";